import { CashBankTransactionStatus } from "../../domain";

export const CASH_BANK_STATUS_OPTIONS: Array<{
  label: string;
  value: CashBankTransactionStatus;
}> = [
  { label: "All", value: "all" },
  { label: "Pending", value: "pending" },
  { label: "Under Review", value: "under_review" },
  { label: "Reconciled", value: "reconciled" },
];
